import React from "react";
import SupportingText from "../SupportingText";
import { Checked } from "../Icons";

export default function AttributeRefinementRow({
  attribute,
  count,
  isRefined
}) {
  return (
    <div className="w-full flex items-center justify-between py-4 pointer-events-none relative">
      <div className="py-1">
        <SupportingText textColor="black" textSize="base">
          {attribute}
        </SupportingText>
      </div>
      {isRefined ? (
        <div
          style={{
            right: "10px"
          }}
          className="absolute"
        >
          <Checked width="28" stroke="#4DC0B5" strokeWidth="2" />
        </div>
      ) : (
        <div className="bg-grey-lightest px-3 py-1 rounded-md">
          <SupportingText textColor="red-light" textSize="base">
            {count}
          </SupportingText>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/AttributeRefinementRow/AttributeRefinementRow.js